import { render } from "./VenueItem.vue?vue&type=template&id=6f3c0321"
import script from "./VenueItem.vue?vue&type=script&lang=js"
export * from "./VenueItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__